import { render, staticRenderFns } from "./UserRoleAddModal.vue?vue&type=template&id=c3361234&scoped=true&"
import script from "./UserRoleAddModal.vue?vue&type=script&lang=js&"
export * from "./UserRoleAddModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleAddModal.vue?vue&type=style&index=0&id=c3361234&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3361234",
  null
  
)

export default component.exports